import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxStarsModule } from 'ngx-stars';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { CustomerEvaluationsRoutingModule } from './customer-evaluations-routing.module';
import { CustomerEvaluationsComponent } from './customer-evaluations.component';
import { BoxContainerComponent } from './box-container/box-container.component';
import { QuestionComponent } from './question/question.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
  declarations: [CustomerEvaluationsComponent, BoxContainerComponent, QuestionComponent],
  imports: [
    CommonModule,
    CustomerEvaluationsRoutingModule,
    NgxStarsModule,
    NgbModule,
    NgxStarsModule,
    FormsModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FontAwesomeModule
  ],
  providers: [
      provideNgxMask({validation: false})
  ]
})
export class CustomerEvaluationsModule { }
